import { Vue } from "vue-property-decorator";
import * as moment from "moment";
import _ from "lodash";

// If token more than 180 minutes old, attempt token refresh
const tokenValidFor = 3 * 60;
const refreshThreshold = tokenValidFor - 60;

export const AuthTokenService = new Vue({
  methods: {
    getRemainingTokenDuration() {
      const payload = this.$auth.getPayload();

      if (!payload) {
        return moment.duration(0);
      }

      const expiryTime = moment.unix(payload.exp).utc();
      const now = moment.utc();
      const diff = moment.duration(expiryTime.diff(now));

      return diff;
    },
    getRemainingTokenSeconds() {
      return Number(
        this.getRemainingTokenDuration()
          .asSeconds()
          .toFixed(0),
      );
    },
    getRemainingTokenMinutes() {
      return this.getRemainingTokenDuration().asMinutes();
    },
    emitTokenRefreshIfNecessary() {
      const diff = this.getRemainingTokenMinutes();
      if (diff < refreshThreshold && diff > 0) {
        this.$eventHub.$emit("REFRESH_TOKEN");
      }
    },
  },
});
